import { render, staticRenderFns } from "./InsightLink.vue?vue&type=template&id=705a8c6a"
import script from "./InsightLink.vue?vue&type=script&lang=js"
export * from "./InsightLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports